export default "__VITE_ASSET__CnvY8PrN__"